{
	"duration": {
		"hoursMinutes": "{hours} ч {minutes} мин",
		"hours": "{hours} ч",
		"minutes": "{minutes} мин"
	},
	"hero": {
		"metricTopics": "{count, plural, one {# тема} few {# темы} many {# тем} other {# тем}}",
		"metricTopicsHint": "{count, plural, one {в # разделе} few {в # разделах} many {в # разделах} other {в # разделах}}",
		"metricTopicsHintPlain": "программа курса",
		"metricDurationHint": "оценка объёма",
		"metricLearners": "{count, plural, one {# ученик} few {# ученика} many {# учеников} other {# учеников}}",
		"metricLearnersHint": "начали курс",
		"authorEyebrow": "Автор курса",
		"platformAuthor": "StudyHub",
		"anonymousAuthor": "Автор не указан",
		"authorCourses": "{count, plural, one {# курс} few {# курса} many {# курсов} other {# курсов}} в каталоге"
	},
	"enroll": {
		"updated": "обновлён {date}",
		"paidNote": "Разовая покупка · доступ навсегда",
		"start": "Начать курс",
		"continue": "Продолжить курс",
		"buy": "Купить курс",
		"closed": "Запись закрыта",
		"closedReason": "Автор ещё не открыл доступ к этому курсу.",
		"review": "Курс на проверке",
		"reviewReason": "Курс появится в каталоге после завершения проверки. До этого момента записаться на него нельзя никому — в том числе вам.",
		"benefitsTitle": "Что вы получите",
		"benefitOwnCopy": "Свой экземпляр курса — прогресс, заметки и повторы только ваши",
		"benefitPlan": "План занятий подстроится под вашу дату экзамена",
		"benefitTutor": "Персональный репетитор внутри курса знает всю его программу",
		"benefitOffline": "Работает офлайн в приложении для iOS и Android"
	},
	"kit": {
		"eyebrow": "Что входит в курс",
		"title": "Каждая тема приходит собранным комплектом",
		"notesTitle": "Конспекты",
		"notesBody": "Структурированный разбор темы: определения, схемы, формулы. Три уровня глубины — от краткого до подробного.",
		"notesNote": "{count, plural, one {# конспект} few {# конспекта} many {# конспектов} other {# конспектов}}",
		"notesNotePlain": "По конспекту на каждую тему",
		"flashcardsTitle": "Карточки с повторением",
		"flashcardsBody": "Интервальное повторение само решает, что показать сегодня: сложное чаще, лёгкое реже.",
		"flashcardsNote": "К каждой теме курса",
		"quizzesTitle": "Тесты по темам",
		"quizzesBody": "Семь типов вопросов с разбором ошибок. После теста — список слабых мест и что подтянуть.",
		"quizzesNote": "С разбором слабых мест",
		"glossaryTitle": "Глоссарий",
		"glossaryBody": "Термины курса с определениями и связями между понятиями. Подсказка по наведению прямо в конспекте.",
		"glossaryNote": "Собирается по материалам курса",
		"tutorTitle": "AI-репетитор курса",
		"tutorBody": "Знает всю программу. Спросите про любую тему — объяснит, разберёт задачу, проверит рассуждение.",
		"tutorNote": "Без ограничений по темам",
		"audioTitle": "Аудио-версия темы",
		"audioBody": "Озвучка на 8–15 минут: подкаст в два голоса или лекция. Слушать в дороге, повторять перед сном.",
		"audioNote": "По запросу к любой теме"
	},
	"flow": {
		"eyebrow": "Как проходит занятие",
		"title": "Три шага на каждую тему",
		"stepsAria": "Шаги маршрута темы",
		"step1Label": "Разобраться",
		"step1Title": "Конспект темы и разбор непонятного",
		"step1Body": "Ключевые идеи, схемы и термины в одном месте. Непонятное место выделяете — репетитор объясняет его отдельно, не уводя со страницы.",
		"step1RowNote": "Конспект темы",
		"step1RowNoteBody": "Определения, схемы и формулы в рабочем порядке",
		"step1RowGlossary": "Термины по наведению",
		"step1RowGlossaryBody": "Определение всплывает прямо в тексте конспекта",
		"step1RowTutor": "Объяснить выделенное",
		"step1RowTutorBody": "Репетитор разбирает конкретный фрагмент, а не тему целиком",
		"step2Label": "Проверить",
		"step2Title": "Карточки на термины и тест на понимание",
		"step2Body": "Курс показывает не только оценку: видно, какие именно подтемы просели и что с ними делать.",
		"step2RowCards": "Карточки на термины",
		"step2RowCardsBody": "Четыре оценки ответа — интервал повтора считается сам",
		"step2RowQuiz": "Тест по теме",
		"step2RowQuizBody": "Уверенность отмечается до ответа, разбор — после",
		"step2RowWeak": "Слабые места",
		"step2RowWeakBody": "Просевшие подтемы попадают в отдельный список",
		"step3Label": "Добрать",
		"step3Title": "Разбор слабых мест и возврат темы в план",
		"step3Body": "По слабым местам репетитор ведёт разбор с цепочкой рассуждений, добавляет карточки на повтор и ставит тему обратно в календарь.",
		"step3RowTutor": "Разбор с цепочкой рассуждений",
		"step3RowTutorBody": "Видно ход решения, а не только готовый ответ",
		"step3RowCards": "Карточки на повтор",
		"step3RowCardsBody": "Добавляются по тем местам, где вы ошиблись",
		"step3RowPlan": "Возврат в календарь",
		"step3RowPlanBody": "Тема встаёт в план на ближайший рабочий день"
	},
	"outcomes": {
		"eyebrow": "Результат",
		"title": "Чему вы научитесь",
		"audienceTitle": "Кому подойдёт",
		"prerequisitesTitle": "Что нужно заранее"
	},
	"program": {
		"eyebrow": "Программа",
		"title": "Разделы и темы курса",
		"summarySections": "{count, plural, one {# раздел} few {# раздела} many {# разделов} other {# разделов}}",
		"summaryTopics": "{count, plural, one {# тема} few {# темы} many {# тем} other {# тем}}",
		"sectionMeta": "{count, plural, one {# тема} few {# темы} many {# тем} other {# тем}}",
		"topicMinutes": "{count} мин"
	},
	"stats": {
		"eyebrow": "Статистика курса",
		"title": "Как курс проходят другие",
		"lead": "Считается по тем, кто уже учится: прогресс, сроки и результаты тестов.",
		"completionValue": "{percent}%",
		"completionLabel": "дошли до конца",
		"completionHint": "{completed, plural, one {# ученик закрыл} few {# ученика закрыли} many {# учеников закрыли} other {# учеников закрыли}} все темы курса",
		"paceLabel": "типичный срок",
		"paceValueDays": "{count, plural, one {# день} few {# дня} many {# дней} other {# дней}}",
		"paceHint": "Медиана по тем, кто прошёл курс целиком",
		"accuracyValue": "{percent}%",
		"accuracyLabel": "средняя точность в тестах",
		"accuracyHint": "По итоговым попыткам",
		"hardestHint": "Самый трудный раздел — «{title}»"
	},
	"author": {
		"eyebrow": "Автор курса",
		"platformTitle": "Курс от StudyHub",
		"platformBody": "Курс подготовлен командой StudyHub совместно с профильными экспертами.",
		"anonymousTitle": "Автор не указан",
		"anonymousBody": "Курс опубликован анонимно: автор решил скрыть свое имя. Материалы прошли автоматическую проверку на соответствие правилам каталога.",
		"coursesCount": "{count, plural, one {# курс} few {# курса} many {# курсов} other {# курсов}} в каталоге",
		"link": "Сайт автора"
	},
	"faq": {
		"eyebrow": "Вопросы",
		"title": "Частые вопросы"
	},
	"related": {
		"eyebrow": "Дальше",
		"title": "Похожие курсы",
		"topics": "{count, plural, one {# тема} few {# темы} many {# тем} other {# тем}}"
	},
	"finalCta": {
		"title": "Начните курс сегодня",
		"lead": "Свой экземпляр курса, план под вашу дату и репетитор, который знает всю программу.",
		"note": "Записаться можно в любой момент — прогресс сохранится."
	},
	"start": {
		"title": "Начать курс",
		"titleNamed": "Начать курс «{title}»",
		"subtitle": "Настройте темп — план разложит темы по дням.",
		"paceLabel": "Когда хотите закончить",
		"paceOwn": "Своим темпом",
		"paceDeadline": "К дате",
		"paceOwnHint": "Без срока: темы встанут в план подряд, дедлайна не будет.",
		"dateLabel": "Дата окончания",
		"minutesLabel": "Минут в день",
		"minutesValue": "{count} мин",
		"daysLabel": "Дни занятий",
		"minDayHint": "Оставьте хотя бы один день недели.",
		"loadNote": "Темп общий для всех ваших курсов — он же используется в календаре.",
		"forecast": "При таком темпе закончите примерно {date}",
		"forecastLate": "К {date} не успеть: при таком темпе курс закончится {estimate}. Добавьте минут в день или дней недели.",
		"forecastUnknown": "Объём курса пока не посчитан — срок покажем, когда программа соберётся.",
		"submit": "Начать курс",
		"cancel": "Отмена",
		"started": "Курс добавлен — открываем",
		"alreadyStarted": "Вы уже проходите этот курс",
		"deadlineError": "Курс создан, но дату окончания сохранить не удалось — задайте её в календаре",
		"error": "Не удалось начать курс",
		"levelLabel": "На какой уровень адаптировать курс?",
		"levelUnset": "Не уточнять",
		"levels": {
			"beginner": "Начальный",
			"intermediate": "Средний",
			"advanced": "Продвинутый"
		},
		"audienceLabel": "Кому объясняем?",
		"audienceAdult": "Взрослому",
		"audienceOptions": {
			"3-7": "Ребёнку 3–7 лет",
			"7-11": "Ребёнку 7–11 лет",
			"11-14": "Подростку 11–14 лет",
			"14-17": "Подростку 14–17 лет"
		},
		"adaptNote": "Программа курса останется авторской — изменится подача: объяснения, тесты, репетитор и озвучка.",
		"wishesLabel": "Пожелания по прохождению",
		"wishesPlaceholder": "Например: больше практики, разбирать на реальных примерах"
	},
	"paid": {
		"title": "Покупка курса",
		"subtitle": "«{title}» — платный курс.",
		"unavailableBody": "Приём оплаты курсов сейчас отключён. Купить этот курс пока нельзя — попробуйте позже.",
		"requiredBody": "Курс открывается после покупки. Оплата из приложения ещё не запущена — как только заработает, кнопка появится здесь.",
		"priceLabel": "Цена",
		"note": "Если вы уже оплатили курс, нажмите «Купить курс» ещё раз — доступ откроется сразу.",
		"close": "Понятно",
		"browseFree": "Бесплатные курсы"
	},
	"report": {
		"trigger": "Пожаловаться",
		"menuTitle": "Действия с курсом",
		"title": "Пожаловаться на курс",
		"subtitle": "Расскажите, что не так с курсом «{title}». Жалобу посмотрит модератор.",
		"reasonLabel": "Причина",
		"reasons": {
			"pii": "Персональные данные",
			"spam": "Спам или реклама",
			"hate_speech": "Оскорбления и вражда",
			"csam": "Материалы с детьми",
			"copyright": "Нарушение авторских прав",
			"inappropriate": "Неприемлемое содержимое",
			"other": "Другое"
		},
		"commentLabel": "Что именно не так",
		"commentOptional": "необязательно",
		"commentPlaceholder": "Опишите проблему: какой раздел, какая тема, что именно нарушает правила.",
		"commentCounter": "{count} из {max}",
		"note": "Мы не сообщаем автору, кто пожаловался. Курс останется доступен тем, кто уже начал его проходить.",
		"submit": "Отправить жалобу",
		"cancel": "Отмена",
		"sent": "Жалоба отправлена — модератор её посмотрит",
		"error": "Не удалось отправить жалобу"
	},
	"review": {
		"pending": {
			"title": "Курс проходит проверку",
			"body": "Пока идёт проверка, эта страница видна только вам: курс не отображается в каталоге и результатах поиска, записаться на него нельзя. Обычно это занимает пару минут."
		},
		"manual": {
			"title": "Курс на проверке у модератора",
			"body": "Автоматическая проверка не смогла принять решение, поэтому курс проверит модератор. Вы ничего не нарушили — нужно просто подождать. Сейчас эта страница видна только вам."
		},
		"rejected": {
			"title": "Курс не прошёл проверку",
			"body": "Курс не соответствует правилам каталога и не был опубликован. Причина указана в уведомлении: исправьте замечания и отправьте курс на публикацию снова. Если вы считаете, что произошла ошибка, обратитесь в поддержку."
		}
	}
}
